export default __webpack_public_path__ + "static/cover-ladder-56b73dea81f86e3a37bce547aba7aa28.png";